// extracted by mini-css-extract-plugin
export default {"microsoftAdsCard":"tia-z","microsoftCarouselCard":"uia-z","displaySixCardTiles":"via-z"};